import React from 'react';

const Footer=()=>{
  return<>
            <section className="footer">

        <div className="share">
            <a href="#" className="btn">facebook</a>
            <a href="#" className="btn">twitter</a>
            <a href="#" className="btn">instagram</a>
            <a href="#" className="btn">pinterest</a>
            <a href="#" className="btn">linkedin</a>
        </div>

        <h1 className="credit"> created by <span>Food Zone Team </span> | all rights reserved! </h1>

    </section>
  </>
}

export default Footer;